/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Cells for Subscriber table
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.0
 */

import { EColumnCell, EColumnFilter } from '../../../../../components/Table/types/columnTypes';
import { SubscriberMobileField } from '../../../../../types/subscriberTypes';

const cellConfig: { [Key in SubscriberMobileField]: number } = {
    accessName: 240,
    account: 150,
    accountName: 140,
    assistantCampaignsCount: 160,
    balance: 140,
    cityNumber: 310,
    contractNumber: 160,
    coordinatorCampaignsCount: 160,
    dcRules: 270,
    icc: 180,
    inn: 140,
    kpp: 140,
    labels: 200,
    loyaltyStatus: 200,
    msisdn: 140,
    name: 200,
    numberType: 200,
    persDataLockDate: 200,
    persDataStatusName: 200,
    position: 160,
    ratePlan: 240,
    status: 110,
    subdivisionKpp: 150,
    subdivisionName: 150,
    zone: 110,
};

const getColumnFilterType = (name: string): string => {
    switch (name) {
        case SubscriberMobileField.accessName:
        case SubscriberMobileField.account:
        case SubscriberMobileField.accountName:
        case SubscriberMobileField.cityNumber:
        case SubscriberMobileField.contractNumber:
        case SubscriberMobileField.dcRules:
        case SubscriberMobileField.icc:
        case SubscriberMobileField.inn:
        case SubscriberMobileField.kpp:
        case SubscriberMobileField.msisdn:
        case SubscriberMobileField.name:
        case SubscriberMobileField.numberType:
        case SubscriberMobileField.persDataStatusName:
        case SubscriberMobileField.position:
        case SubscriberMobileField.ratePlan:
        case SubscriberMobileField.status:
        case SubscriberMobileField.subdivisionKpp:
        case SubscriberMobileField.subdivisionName:
        case SubscriberMobileField.zone:
            return EColumnFilter.filterMultiSelect;
        case SubscriberMobileField.assistantCampaignsCount:
        case SubscriberMobileField.coordinatorCampaignsCount:
        case SubscriberMobileField.loyaltyStatus:
            return EColumnFilter.filterSelect;
        case SubscriberMobileField.persDataLockDate:
            return EColumnFilter.filterDate;
        case SubscriberMobileField.balance:
            return EColumnFilter.filterRange;
        case SubscriberMobileField.labels:
            return EColumnFilter.filterLabelMultiSelect;
        default:
            return '';
    }
};

const getColumnCellType = (name: SubscriberMobileField): string => {
    switch (name) {
        case SubscriberMobileField.msisdn:
            return EColumnCell.linkMobile;
        case SubscriberMobileField.account:
            return EColumnCell.linkAccountNumber;
        case SubscriberMobileField.assistantCampaignsCount:
        case SubscriberMobileField.coordinatorCampaignsCount:
            return EColumnCell.linkCampaignNumber;
        case SubscriberMobileField.cityNumber:
        case SubscriberMobileField.subdivisionKpp:
        case SubscriberMobileField.subdivisionName:
            return EColumnCell.notEmpty;
        case SubscriberMobileField.labels:
            return EColumnCell.labels;
        case SubscriberMobileField.balance:
            return EColumnCell.balance;
        case SubscriberMobileField.persDataLockDate:
            return EColumnCell.dateCell;
        case SubscriberMobileField.persDataStatusName:
            return EColumnCell.persDataStatusName;
        case SubscriberMobileField.accessName:
        case SubscriberMobileField.accountName:
        case SubscriberMobileField.contractNumber:
        case SubscriberMobileField.dcRules:
        case SubscriberMobileField.icc:
        case SubscriberMobileField.loyaltyStatus:
        case SubscriberMobileField.name:
        case SubscriberMobileField.numberType:
        case SubscriberMobileField.position:
        case SubscriberMobileField.ratePlan:
        case SubscriberMobileField.status:
        case SubscriberMobileField.zone:
        default:
            return EColumnCell.text;
    }
};

const getColumnFixedType = (name: SubscriberMobileField): string | boolean => {
    switch (name) {
        case SubscriberMobileField.msisdn:
            return 'left';
        default:
            return false;
    }
};

export {
    cellConfig,
    getColumnCellType,
    getColumnFilterType,
    getColumnFixedType,
};
